import React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

const DodaIcon = () => {
  return (
    <Svg viewBox="0 0 48 48" width="40px" height="40px">
      <Circle cx="24" cy="24" r="22" fill="#334155" />
      <Path
        fill="#fff"
        d="M15 12.5H23.5C29.5 12.5 34 17 34 24C34 31 29.5 35.5 23.5 35.5H15V12.5ZM19.5 16.5V31.5H23.5C27 31.5 29.7 28.5 29.7 24C29.7 19.5 27 16.5 23.5 16.5H19.5Z"
      />
    </Svg>
  );
};

export default DodaIcon;
